/**
 * REGISTRO DE ERRORES DEL PANEL — A LA CONSOLA, Y A NINGÚN LADO MÁS.
 *
 * Antes esto era `@sentry/vue`, encendido con una variable de entorno que
 * inyectaba el DSN en la página. Estaba apagado, pero «apagado» y «no puede
 * encenderse» no son lo mismo: cualquiera que setee esa variable empezaba a
 * mandarle a un tercero los errores del panel, y con ellos el contexto que
 * viaja adjunto —identificadores de conversaciones, de contactos, de cuentas—
 * sin que nadie lo decidiera.
 *
 * Este archivo conserva la MISMA superficie que se usaba (`captureException` y
 * `setContext`) para que los lugares que ya reportaban sigan reportando sin
 * tocar su lógica. Cambia el destino, no el hábito.
 *
 * Los errores del panel se leen en la consola del navegador. Los del servidor
 * —que son los que importan para el bot— salen por el log, con prefijo fijo.
 */

// El contexto se acumula acá y se vuelca junto al error, que es lo que lo hace
// útil: un error suelto sin el identificador de la conversación no se puede
// perseguir.
const contexto = {};

export const setContext = (nombre, datos) => {
  if (!nombre) return;
  contexto[nombre] = datos;
};

export const captureException = error => {
  const adjunto = Object.keys(contexto).length ? contexto : undefined;

  // eslint-disable-next-line no-console
  console.error('[PANEL][ERROR]', error, adjunto);
};

export default { setContext, captureException };
